<div class="PGDuration">
    <div class="input-group" ngbDropdown>
        <input [id]="fieldId" class="form-control" [readonly]="readonly" [(ngModel)]="unitValue" (ngModelChange)="onUnitValueChange()">

        <button ngbDropdownToggle [disabled]="readonly" class="btn btn-secondary">{{ getSelectedUnit().text | locTranslate }}</button>
        <div ngbDropdownMenu>
            @for (item of unitOptions; track item) {
                <div class="dropdown-item {{item.id == unit ? 'active disabled' : ''}}" (click)="setSelectedUnit(item.id)">
                    {{ item.text | locTranslate }}
                </div>
            }
        </div>
    </div>
</div>